export const ASSESSMENT_ATTEMPT_STATUS = {
  COMPLETED: "completed",
  IN_PROGRESS: "in_progress",
  NOT_STARTED: "not_started",
} as const;

export type AssessmentAttemptStatus =
  | (typeof ASSESSMENT_ATTEMPT_STATUS)[keyof typeof ASSESSMENT_ATTEMPT_STATUS]
  | null;

export type ExitTicketBestScore = {
  score: number | null;
  correct_count: number | null;
  total_questions: number | null;
  submitted_at: string | null;
};

export type AssessmentAttemptStatuses = {
  exit_ticket: AssessmentAttemptStatus;
  pre_assessment: AssessmentAttemptStatus;
  exit_ticket_best?: ExitTicketBestScore | null;
};
